import { Box, Grid } from "@mui/material";
import './style.scss';

export default function Banner() {
  return (
    <Box className="main-banner">
      <Box className="title">Giá đơn vị Quỹ Manulife</Box>
      <Grid container>
        <Grid size={{ md: 9, sm: 12, xs: 12 }} className="banner">
        </Grid>
        <Grid size={{ md: 3, sm: 12, xs: 12 }} className="teaser">
          <p>Tận hưởng tương lai tự do tài chính cùng sự bảo vệ ưu việt từ Manulife</p>
        </Grid>
      </Grid>
    </Box>
  );
}